import { Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductReference } from "src/app/models/layout/product-reference";
import { ApiService } from 'src/app/services/api.service';
import { ModalService } from 'src/app/services/modal.service';
import { PlanogramService } from 'src/app/services/planogram.service';
import { ManufacturerReportModalComponent } from '../reports/manufacturer-report-modal/manufacturer-report-modal.component';
import { BrandReportModalComponent } from '../reports/brand-report-modal/brand-report-modal.component';
import { SegmentReportModalComponent } from '../reports/segment-report-modal/segment-report-modal.component';
import { SegmentBrandReportModalComponent } from '../reports/segment-brand-report-modal/segment-brand-report-modal.component';
import { Top15ReportModalComponent } from '../reports/top15-report-modal/top15-report-modal.component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-select-report-modal',
    templateUrl: './select-report-modal.component.html',
    styleUrls: ['./select-report-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule]
})
export class SelectReportModalComponent {
  reportTypes = [
    { id: 'manufacturer', name: 'Manufacturer Breakdown' },
    { id: 'brand', name: 'Brand Breakdown' },
    { id: 'segment', name: 'Segments Breakdown' },
    { id: 'segmentBrand', name: 'Brands Segment Breakdown' },
    { id: 'top15', name: 'Top 15 Products' }
  ];

  selectedReport: string = '';
  reportData: any = null;

  constructor(public activeModal: NgbActiveModal, private apiService: ApiService, private planogramService: PlanogramService,
    private modalService: ModalService) { }

    showReport() {
    switch(this.selectedReport) {
      case 'manufacturer':
        this.modalService.openModalWithOptions(ManufacturerReportModalComponent, { size: 'xl', centered: true });
        break;
      case 'brand':
        this.modalService.openModalWithOptions(BrandReportModalComponent, { size: 'xl', centered: true });
        break;
      case 'segment':
        this.modalService.openModalWithOptions(SegmentReportModalComponent, { size: 'xl', centered: true });
        break;
      case 'segmentBrand':
        this.modalService.openModalWithOptions(SegmentBrandReportModalComponent, { size: 'xl', centered: true });
        break;
      case 'top15':
        this.modalService.openModalWithOptions(Top15ReportModalComponent, { size: 'xl', centered: true });
        break;
      default:
        alert('Please select a report to view')
    }
  }

  

  ngOnInit(): void {
  }

  confirm(): void {
    this.activeModal.close();
  }

  cancel(): void {
    this.activeModal.close(null);
  }
}
